import { useTheme } from "../hooks/useTheme";
import { useTranslation } from "../i18n";

/** Sun/moon icons drawn inline so no icon dependency is needed. */
function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <circle cx="12" cy="12" r="4.2" fill="currentColor" />
      <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
        <path d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2" />
        <path d="M5.4 5.4l1.6 1.6M17 17l1.6 1.6M18.6 5.4L17 7M7 17l-1.6 1.6" />
      </g>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <path
        d="M20 14.2A8.2 8.2 0 0 1 9.8 4a8.4 8.4 0 1 0 10.2 10.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ThemeToggle() {
  const { resolved, toggle } = useTheme();
  const { t } = useTranslation();
  const goingDark = resolved === "light";

  return (
    <button
      onClick={toggle}
      aria-label={goingDark ? t("nav.switchToDark") : t("nav.switchToLight")}
      title={goingDark ? t("nav.darkTheme") : t("nav.lightTheme")}
      className="flex h-9 w-9 items-center justify-center rounded-lg text-ink-muted transition-colors hover:bg-surface-sunken hover:text-ink"
    >
      {goingDark ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
